import { styled } from "@mui/material";

import { TruncatedText } from "@citrine/atoms/truncated-text";

export const Container = styled(TruncatedText)(({ theme }) => ({
  alignItems: "center",
  display: "flex",
  gap: theme.spacing(1),
}));

export const TeamName = styled(TruncatedText)(({ theme }) => ({
  fontSize: theme.typography.fontSizeMd,
  fontWeight: theme.typography.fontWeightMedium,
}));
